import React from 'react';
import { useAuth } from '../hooks/useAuth';

interface SessionTimeoutModalProps {
  onDismiss: () => void;
}

export function SessionTimeoutModal({ onDismiss }: SessionTimeoutModalProps) {
  const { logout } = useAuth();

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-white rounded-lg shadow-xl p-6 max-w-sm mx-4">
        <h2 className="text-lg font-semibold text-gray-900 mb-2">
          Session Expiring
        </h2>
        <p className="text-sm text-gray-600 mb-6">
          Your session will expire in 5 minutes due to inactivity.
        </p>
        <div className="flex gap-3">
          <button
            onClick={onDismiss}
            className="flex-1 py-2 px-4 bg-blue-600 text-white rounded-md font-medium hover:bg-blue-700 transition-colors"
          >
            Stay Logged In
          </button>
          <button
            onClick={logout}
            className="flex-1 py-2 px-4 border border-gray-300 text-gray-700 rounded-md font-medium hover:bg-gray-50 transition-colors"
          >
            Log Out
          </button>
        </div>
      </div>
    </div>
  );
}
